import { PaymentLocalizationForm } from 'components/forms';

const FinancesPaymentLocalizationCreate = () => (
  <PaymentLocalizationForm />
);

export default FinancesPaymentLocalizationCreate;